/**
 * Which sound the phone rings with when a call comes IN.
 *
 * Two answers: the trill this front end ships with, or a file the operator
 * uploaded under CRM Settings -> Phone. The uploaded one wins.
 *
 * The holder itself lives in `../ownSound.ts`, which the outgoing ring shares -
 * the two are the same fact about two different moments, and the file there
 * carries the reasoning for why an address is pushed in rather than fetched.
 * What stays here is the one thing that is only true of this ring: it always
 * has something to play, because we ship a default.
 */
import { createOwnSound } from "../ownSound";

/** The trill in `public/`. Regenerate with `scripts/make-ring.mjs`. */
export const DEFAULT_RING_URL = "/ring.wav";

const sound = createOwnSound(DEFAULT_RING_URL);

/** Records the operator's own ringtone, or clears it back to the default. */
export function setRingSource(url: string | null | undefined): void {
  sound.set(url);
}

/** The address to ring with. Never empty. */
export function ringSource(): string {
  return sound.url();
}

/** True when the operator has chosen their own sound. */
export function hasCustomRing(): boolean {
  return sound.hasCustom();
}
